
  import { computed, defineComponent, onMounted, ref, toRefs } from 'vue';
  import { useScheduleStore } from '@/stores/schedule/schedule';
  import ChooseUserFieldWithSelectAll from '@/ui/components/user/ChooseUserFieldWithSelectAll.vue';
  import { CheckboxField, DropdownField, InputField, TagField } from '@/ui/components/form';
  import CheckboxGroup from '@/_legacy/components/CheckboxGroup.vue';
  import { ChooseEntityItemField } from '@/ui/components/entityItem/ChooseEntityItemField';
  import { Button } from '@/ui/components/Button';
  import { Field } from '@/ui/components/form/Field';
  import { CreateUserModelIdentifier } from '@/ui/components/user/CreateUserModal';
  import { separateTodoValues } from '@/ui/pages/scheduleManager/separateTodoOptions';
  import { fromUnixTime, getUnixTime } from 'date-fns';
  import { user } from '@/ui/auth/auth';
  import { directions, scales, types } from '@/ui/pages/scheduleManager/reminderOptions';
  import { ScheduleFormProps } from '@/ui/components/schedule/scheduleFormProps';
  import RRule from '@/ui/components/rrule/RRule.vue';
  import { Days } from '@/entities/rrule/constants';
  import { Icon } from '@/ui/components/icon/Icon';

  export default defineComponent<ScheduleFormProps>({
    components: {
      ChooseUserFieldWithSelectAll,
      CheckboxField,
      DropdownField,
      CheckboxGroup,
      ChooseEntityItemField,
      TagField,
      InputField,
      Button,
      Field,
      RRule,
      Icon,
    },
    props: [
      'userSelectOptions',
      'entityItemOptions',
      'checklistOptions',
      'sendRecordTask',
      'errors',
      'hasNoErrors',
      'showErrors',
    ],
    setup(props, ctx) {
      const {
        userSelectOptions,
        sendRecordTask,
        errors,
        hasNoErrors,
        showErrors,
      } = toRefs(props);

      const store = useScheduleStore();
      const assigneesUserIdentifier = CreateUserModelIdentifier.scheduleCreatorAssignees;
      const supervisorsUserIdentifier = CreateUserModelIdentifier.scheduleCreatorSupervisors;
      const shouldSelectSupervisors = ref<boolean>(false);

      onMounted(async () => {
        shouldSelectSupervisors.value = store.record.supervisors.length > 0 || store.record.supervisorGroups.length > 0;
      });

      const selectSupervisors = (value: boolean) => {
        shouldSelectSupervisors.value = value;
        if (!value) {
          store.updateSupervisors([]);
        }
      };

      const dueAt = computed(() => fromUnixTime(
        getUnixTime(store.record.rule.start!) + ((store.record.dueIn ?? 60) * 60),
      ));

      const entityItemSelectable = () => user.value.entityItems.length > 0 || props.entityItemOptions.length > 0;

      const updateUserOptions = () => {
        ctx.emit('update-user-options');
      };

      const updateDay = (v: { value: boolean; day: Days }) => {
        store.changeDay(v.value, v.day);
      };

      return {
        ...store,
        updateDay,
        userOptions: userSelectOptions,
        entityOptions: props.entityItemOptions,
        assigneesUserIdentifier,
        supervisorsUserIdentifier,
        validationErrors: errors,
        hasNoValidationErrors: hasNoErrors,
        showValidationErrors: showErrors,
        shouldSelectSupervisors,
        dueAt,
        separateTodoValues: separateTodoValues(),
        reminderValueOptions: scales,
        reminderDirections: directions,
        reminderTypes: types,
        sendRecord: sendRecordTask,
        selectSupervisors,
        entityItemSelectable,
        updateUserOptions,
      };
    },
  });
